module.exports = __webpack_public_path__ + "img/special_kingOfTheHill.14163339.png";